import * as React from 'react';

import {SchedulerFeatureGate} from '../../limits/feature-gates/scheduler-feature-gate';

import {ShareMeetingModal} from './share-meeting-modal';

type Props = {
    meetingIsActive: boolean;
    publicMeetingLink: string;
    embedSnippet: string;
    isOpen: boolean;
    onClose: () => void;
};

export function ShareMeetingModalComponent(props: Props) {
    return NutClientConfig.canUseScheduler ? (
        <ShareMeetingModal
            onClose={props.onClose}
            meetingIsActive={props.meetingIsActive}
            publicMeetingLink={props.publicMeetingLink}
            embedSnippet={props.embedSnippet}
        />
    ) : (
        <SchedulerFeatureGate isOpen={props.isOpen} onClose={props.onClose} />
    );
}
